var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useId, useState } from 'react';
import { useGeocoding } from '../../_shared/components/arcgis-map/hooks/useGeocoding';
const MIN_SEARCH_LENGTH = 3;
const SEARCH_DELAY_MS = 300;
/**
 * Where a new district's starting area goes: a city or town, looked up with the ArcGIS geocoder as
 * the person types. Only a picked suggestion counts; typing again clears it, so the area is never
 * placed from text nobody confirmed.
 */
const StartingPlaceField = (props) => {
    var _a, _b;
    const inputId = useId();
    const { searchAddress, isLoading } = useGeocoding();
    const [query, setQuery] = useState((_b = (_a = props.value) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '');
    const [suggestions, setSuggestions] = useState([]);
    useEffect(() => {
        const text = query.trim();
        if (props.value || text.length < MIN_SEARCH_LENGTH) {
            setSuggestions([]);
            return;
        }
        let current = true;
        const timer = setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
            const found = yield searchAddress(text, undefined, ['City']);
            if (current)
                setSuggestions(found);
        }), SEARCH_DELAY_MS);
        return () => {
            current = false;
            clearTimeout(timer);
        };
    }, [query, props.value, searchAddress]);
    const handleType = (text) => {
        setQuery(text);
        if (props.value)
            props.onChange(null);
    };
    const handlePick = (candidate) => {
        setQuery(candidate.address);
        setSuggestions([]);
        props.onChange({ label: candidate.address, point: candidate.location });
    };
    return (_jsxs(_Fragment, { children: [_jsx("label", { htmlFor: inputId, className: "form-label", children: "City and state (optional)" }), _jsxs("div", { className: "position-relative", children: [_jsxs("div", { className: "d-flex gap-2", children: [_jsx("input", { id: inputId, type: "text", className: "form-control", placeholder: "e.g. Camp Hill, PA", autoComplete: "off", value: query, onChange: e => handleType(e.target.value) }), isLoading && (_jsx("div", { className: "d-flex align-items-center px-2", children: _jsx("span", { className: "spinner-border spinner-border-sm text-muted" }) }))] }), suggestions.length > 0 && (_jsx("ul", { className: "list-group position-absolute w-100 mt-1 shadow", style: { zIndex: 20 }, "aria-label": "Places found", children: suggestions.map((s, i) => (
                        // The geocoder can suggest two places with the same name.
                        _jsx("li", { className: "list-group-item p-0", children: _jsxs("button", { type: "button", className: "btn btn-link text-start text-decoration-none text-body w-100 px-3 py-2", onClick: () => handlePick(s), children: [_jsx("i", { className: "bi bi-geo-alt me-2", "aria-hidden": "true" }), _jsx("small", { children: s.address })] }) }, `${i}-${s.address}`))) }))] }), _jsx("div", { className: "form-text", children: props.value
                    ? `The starting area goes around ${props.value.label}.`
                    : 'Pick a suggestion to put the starting area there. Without one, it starts in the middle of the contiguous United States.' })] }));
};
export default StartingPlaceField;
